import axios from "axios";
import axiosConstants from "../axiosConstants";
import { isIssuer } from "../role-helpers";
import {
  PermissionsInterface,
  RequestResponse,
  User,
  UserType
} from "../types";

// eslint-disable-next-line import/no-mutable-exports
let domainCode: string;
export const getUsersAndPermissions: () => Promise<RequestResponse<User>> =
  async () => {
    try {
      const userRequest = axios.get(axiosConstants.USER_URL);
      const permissionsRequest = axios.get(axiosConstants.PERMISSIONS_URL);
      const [userResponse, permissionsResponse] = await Promise.all([
        userRequest,
        permissionsRequest
      ]);

      if (!userResponse.data || !permissionsResponse.data) {
        throw Error("User and permissions data not found");
      }

      if (permissionsResponse.data.length === 0 || !permissionsResponse.data) {
        throw Error("User permission data not found");
      }

      domainCode = userResponse.data.domainCode;
      console.log(domainCode);

      const permissionsMap: PermissionsInterface =
        permissionsResponse.data.reduce(
          (map: any, permission: { authority: string }) => ({
            ...map,
            [permission.authority]: true
          }),
          {}
        );

      const userType: UserType = isIssuer(permissionsMap)
        ? "ISSUER"
        : "ISW_ADMIN";

      const data: User = {
        ...userResponse.data,
        permissionsMap,
        userType,
        domainCode
      };
      return { error: false, data };
    } catch (e) {
      console.log("Error fetching user and permissions: ", e);
      return {
        error: true,
        message: `Error fetching user and permissions: ${(e as Error).message}`,
        data: null
      };
    }
  };

export { domainCode };
